(function (root, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.InextCartPickupAvailability = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  var PERMANENTLY_EXCLUDED_CODES = ['JBPB', 'MUMB'];

  function normalizeText(value) {
    return String(value == null ? '' : value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function normalizeCode(value) {
    return String(value == null ? '' : value).trim().toUpperCase();
  }

  function aggregateCartLines(cart) {
    var totals = new Map();
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    items.forEach(function (item) {
      if (!item || item.requires_shipping === false) return;

      var sku = String(item.sku == null ? '' : item.sku).trim();
      var quantity = Number(item.quantity);

      if (!sku) {
        throw new Error('Every physical cart line must have a SKU');
      }
      if (!Number.isInteger(quantity) || quantity <= 0) {
        throw new Error('Every physical cart line must have a positive integer quantity');
      }

      totals.set(sku, (totals.get(sku) || 0) + quantity);
    });

    return Array.from(totals, function (entry) {
      return { sku: entry[0], quantity: entry[1] };
    }).sort(function (left, right) {
      return left.sku.localeCompare(right.sku);
    });
  }

  function buildStoreIndex(stores) {
    var rows = Array.isArray(stores) ? stores : [];

    return rows.map(function (store) {
      return {
        code: normalizeCode(store && store.refCode),
        name: normalizeText(store && store.name),
        city: normalizeText(store && store.city),
        pincode: String(store && store.pincode == null ? '' : store.pincode).trim(),
        store: store,
      };
    }).filter(function (entry) {
      return entry.code && entry.name;
    });
  }

  function matchStoreCode(text, storeIndex) {
    var normalized = normalizeText(text);
    var entries = Array.isArray(storeIndex) ? storeIndex : [];
    if (!normalized) return null;

    var nameMatches = entries.filter(function (entry) {
      return normalized.indexOf(entry.name) !== -1;
    });
    if (!nameMatches.length) return null;

    var pincodesInText = normalized.match(/\b\d{6}\b/g) || [];
    if (pincodesInText.length) {
      var exactMatches = nameMatches.filter(function (entry) {
        return entry.pincode && pincodesInText.indexOf(entry.pincode) !== -1;
      });
      return exactMatches.length === 1 ? exactMatches[0].code : null;
    }

    return nameMatches.length === 1 ? nameMatches[0].code : null;
  }

  function filterLocations(locations, eligibleCodes, excludedCodes, storeIndex) {
    var eligible = new Set((eligibleCodes || []).map(normalizeCode));
    var excluded = new Set(PERMANENTLY_EXCLUDED_CODES);
    (excludedCodes || []).forEach(function (code) {
      excluded.add(normalizeCode(code));
    });

    return (Array.isArray(locations) ? locations : []).filter(function (location) {
      var text = typeof location === 'string' ? location : location && location.text;
      var code = matchStoreCode(text, storeIndex);
      return Boolean(code && eligible.has(code) && !excluded.has(code));
    });
  }

  function cartSignature(items) {
    return (Array.isArray(items) ? items : [])
      .map(function (item) {
        return { sku: String(item.sku || '').trim(), quantity: Number(item.quantity) };
      })
      .sort(function (left, right) {
        return left.sku.localeCompare(right.sku);
      })
      .map(function (item) {
        return item.sku + ':' + item.quantity;
      })
      .join('|');
  }

  function createAvailabilityCache() {
    var values = new Map();
    return {
      get: function (signature) {
        return values.has(signature) ? values.get(signature) : null;
      },
      set: function (signature, result) {
        values.set(signature, result);
      },
      delete: function (signature) {
        values.delete(signature);
      },
    };
  }

  function describeLocation(text, storeIndex, eligibleCodes, excludedCodes) {
    var code = matchStoreCode(text, storeIndex);
    if (!code) return { code: null, visible: false };

    var visible = filterLocations(
      [{ text: text }],
      eligibleCodes,
      excludedCodes,
      storeIndex
    ).length === 1;
    return { code: code, visible: visible };
  }

  function shouldInvalidateSelection(checked, visible) {
    return Boolean(checked && !visible);
  }

  function buildPickupAttributeCleanup() {
    return {
      pickup: '',
      Pickup_Information: '',
      Pickup_Store: '',
      Pickup_StoreID: '',
      _formattedDate: '',
      _unixTimestamp: '',
      Pickup_date: '',
      Pickup_time: '',
      Pickup_name: '',
      Pickup_phone: '',
      'Pickup Store': '',
      'Store Code': '',
      'Pickup Date': '',
      'Pickup Time': '',
      City: '',
      Pincode: '',
    };
  }

  function getStatusPlacement(widget) {
    var storeList = widget.container.querySelector('#storeUL');
    if (storeList && storeList.parentElement === widget.container) {
      return { parent: widget.container, before: storeList };
    }
    if (widget.prompt !== widget.container && widget.prompt.parentElement) {
      return { parent: widget.prompt.parentElement, before: widget.prompt.nextSibling };
    }
    return { parent: widget.container, before: null };
  }

  function setRowVisible(row, visible) {
    if (!row) return;
    row.hidden = !visible;
    row.style.display = visible ? '' : 'none';
    row.classList.toggle('inext-pickup-location--hidden', !visible);
    row.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function setStoreListVisible(widget, visible) {
    var storeList = widget && widget.container && widget.container.querySelector('#storeUL');
    if (!storeList) return;
    setRowVisible(storeList, visible);
  }

  function findLocationRowElement(radio, documentRef, cssEscape) {
    if (!radio) return null;

    var row = radio.closest && radio.closest('li');
    if (row) return row;

    var label = null;
    if (radio.id && documentRef && documentRef.querySelector) {
      label = documentRef.querySelector('label[for="' + cssEscape(radio.id) + '"]');
    }
    return label || (radio.closest && radio.closest('label, [class*="location"], [class*="store"]')) || radio.parentElement;
  }

  function createRuntime(api, config, browser) {
    var cache = createAvailabilityCache();
    var inFlight = new Map();
    var storeIndex = null;
    var scheduled = null;
    var currentSignature = null;
    var invalidationInFlight = false;
    var fetchImpl = browser.fetch.bind(browser);
    var documentRef = browser.document;

    function fetchJson(url, options) {
      return fetchImpl(url, options).then(function (response) {
        if (!response.ok) {
          var error = new Error('Request failed with status ' + response.status);
          error.status = response.status;
          throw error;
        }
        return response.json();
      });
    }

    function loadStores() {
      if (storeIndex) return Promise.resolve(storeIndex);
      return fetchJson(config.storesUrl).then(function (payload) {
        storeIndex = buildStoreIndex(Array.isArray(payload) ? payload : payload.data);
        return storeIndex;
      });
    }

    function findPrompt() {
      var walker = documentRef.createTreeWalker(documentRef.body, browser.NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (normalizeText(node.nodeValue).indexOf('choose a location below for pickup') !== -1) {
          return node.parentElement;
        }
      }
      return null;
    }

    function findWidget() {
      var prompt = findPrompt();
      if (!prompt) return null;

      var container = prompt;
      for (var depth = 0; container && depth < 8; depth += 1, container = container.parentElement) {
        var radios = Array.from(container.querySelectorAll('input[type="radio"]'));
        if (radios.length) return { prompt: prompt, container: container, radios: radios };
      }
      return null;
    }

    function findLocationRow(radio, index) {
      return findLocationRowElement(radio, documentRef, browser.CSS.escape.bind(browser.CSS));
    }

    function ensureStatus(widget) {
      var status = widget.container.querySelector('[data-inext-pickup-status]');
      if (!status) {
        status = documentRef.createElement('div');
        status.setAttribute('data-inext-pickup-status', '');
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        status.style.cssText = 'margin:8px 0;font-size:14px;line-height:1.4;color:#6e6e73;';
        var placement = getStatusPlacement(widget);
        placement.parent.insertBefore(status, placement.before);
      }
      return status;
    }

    function setStatus(widget, state, message) {
      var status = ensureStatus(widget);
      status.dataset.state = state;
      if (status.textContent !== message) status.textContent = message;
      return status;
    }

    function hideAllRows(widget, index) {
      widget.radios.forEach(function (radio) {
        setRowVisible(findLocationRow(radio, index), false);
      });
    }

    function clearPickupSelection() {
      if (invalidationInFlight) return Promise.resolve();
      invalidationInFlight = true;
      try {
        browser.localStorage.removeItem('selectedStore');
      } catch (_error) {
        // Storage can be disabled without affecting cart cleanup.
      }

      return fetchJson('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: buildPickupAttributeCleanup(),
        }),
      }).catch(function () {
        // The row remains unavailable even if cart-attribute cleanup needs another attempt.
      }).finally(function () {
        invalidationInFlight = false;
      });
    }

    function applyResult(widget, index, result) {
      var eligibleCodes = result.data.eligibleBranchCodes || [];
      var excludedCodes = config.excludedBranchCodes || [];
      var visibleCount = 0;
      var invalidated = false;

      widget.radios.forEach(function (radio) {
        var row = findLocationRow(radio, index);
        var decision = describeLocation(row && (row.innerText || row.textContent), index, eligibleCodes, excludedCodes);
        setRowVisible(row, decision.visible);
        if (decision.visible) visibleCount += 1;

        if (shouldInvalidateSelection(radio.checked, decision.visible)) {
          radio.checked = false;
          radio.dispatchEvent(new browser.Event('change', { bubbles: true }));
          invalidated = true;
        }
      });

      if (invalidated) clearPickupSelection();

      setStoreListVisible(widget, visibleCount > 0);

      if (!visibleCount) {
        setStatus(widget, 'empty', 'No pickup store currently has every item in your cart. Please choose Shipping.');
      } else if (result.meta && result.meta.inventoryFreshness === 'stale') {
        setStatus(widget, 'stale', 'Store availability is based on a recent inventory update.');
      } else {
        setStatus(widget, 'ready', 'Showing stores that can fulfil every item in your cart.');
      }
    }

    function requestAvailability(signature, items, force) {
      if (!force) {
        var cached = cache.get(signature);
        if (cached) return Promise.resolve(cached);
      }
      if (inFlight.has(signature)) return inFlight.get(signature);

      var request = fetchJson(config.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      }).then(function (result) {
        if (!result || !result.success || !result.data) throw new Error('Invalid availability response');
        cache.set(signature, result);
        return result;
      }).finally(function () {
        inFlight.delete(signature);
      });
      inFlight.set(signature, request);
      return request;
    }

    function showUnavailable(widget, index, error) {
      hideAllRows(widget, index);
      var status = setStatus(
        widget,
        'unavailable',
        'We could not verify store inventory. Please retry or choose Shipping.'
      );
      var retry = documentRef.createElement('button');
      retry.type = 'button';
      retry.textContent = 'Retry';
      retry.style.cssText = 'margin-left:8px;padding:4px 10px;cursor:pointer;';
      retry.addEventListener('click', function () {
        if (currentSignature) cache.delete(currentSignature);
        run(true);
      });
      status.appendChild(retry);
      if (browser.console && browser.console.warn) browser.console.warn('Pickup inventory unavailable', error);
    }

    function run(force) {
      var widget = findWidget();
      if (!widget) return Promise.resolve(false);

      return Promise.all([fetchJson('/cart.js'), loadStores()]).then(function (values) {
        var items = aggregateCartLines(values[0]);
        var index = values[1];
        var signature = cartSignature(items);
        currentSignature = signature;
        hideAllRows(widget, index);
        setStatus(widget, 'loading', 'Checking store inventory…');

        if (!items.length) {
          setStatus(widget, 'empty', 'Pickup is unavailable because the cart has no physical items.');
          return false;
        }

        return requestAvailability(signature, items, force).then(function (result) {
          applyResult(findWidget() || widget, index, result);
          return true;
        });
      }).catch(function (error) {
        showUnavailable(findWidget() || widget, storeIndex || [], error);
        return false;
      });
    }

    function schedule() {
      if (scheduled) browser.clearTimeout(scheduled);
      scheduled = browser.setTimeout(function () {
        scheduled = null;
        run(false);
      }, 150);
    }

    function start() {
      run(false);
      var observer = new browser.MutationObserver(function (mutations) {
        var onlyAdapterStatusChanged = mutations.length && mutations.every(function (mutation) {
          var element = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
          return element && element.closest('[data-inext-pickup-status]');
        });
        if (!onlyAdapterStatusChanged) schedule();
      });
      observer.observe(documentRef.body, { childList: true, subtree: true });
      documentRef.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name="updates[]"], [data-quantity-variant-id]')) {
          schedule();
        }
      });
      return observer;
    }

    return { start: start, run: run };
  }

  return {
    PERMANENTLY_EXCLUDED_CODES: PERMANENTLY_EXCLUDED_CODES.slice(),
    aggregateCartLines: aggregateCartLines,
    buildStoreIndex: buildStoreIndex,
    matchStoreCode: matchStoreCode,
    filterLocations: filterLocations,
    cartSignature: cartSignature,
    createAvailabilityCache: createAvailabilityCache,
    describeLocation: describeLocation,
    shouldInvalidateSelection: shouldInvalidateSelection,
    buildPickupAttributeCleanup: buildPickupAttributeCleanup,
    getStatusPlacement: getStatusPlacement,
    setRowVisible: setRowVisible,
    setStoreListVisible: setStoreListVisible,
    findLocationRowElement: findLocationRowElement,
    createRuntime: createRuntime,
  };
});

if (typeof window !== 'undefined' && window.document) {
  var startInextCartPickup = function () {
    if (!window.InextCartPickupConfig || window.__inextCartPickupRuntime) return;
    window.__inextCartPickupRuntime = window.InextCartPickupAvailability.createRuntime(
      window.InextCartPickupAvailability,
      window.InextCartPickupConfig,
      window
    );
    window.__inextCartPickupRuntime.start();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startInextCartPickup, { once: true });
  } else {
    startInextCartPickup();
  }
}
